import OminityForms from './forms';

window.OminityForms = OminityForms;

export {
    OminityForms,
};
